<template>
<div>
  <post v-if="post" :options="{ widget: { id: post } }" />
  <div v-else >
    <div v-loading="loading" >Board non accessible</div>
  </div>
</div>
</template>

<script>
import Board from '../Board'
import Post from 'macarons-blog/Post'

export default {
  components: {
    Board,
    Post
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    post () {
      return window[window.macarons].homePost || null
    }
  },
  mounted () {
    if (!this.post) {
      this.loading = true
      this.$store.commit('setId', null)
      this.$store.dispatch('loadBoard').then(() => {
        return this.$store.dispatch('getBoardAccess', this.$store.state.board.id).then(access => {
          if (access) {
            this.$router.push('/boards/' + this.$store.state.board.id)
          }
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/components/Home.vue